import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	openChat: {
		id: 'offlineChat.openChat',
		defaultMessage: 'Открыть чат',
	},
	applicationAccepted: { id: 'offlineChat.applicationAccepted', defaultMessage: 'Ваша заявка принята.' },
	thanksForApplication: { id: 'offlineChat.thanksForApplication', defaultMessage: 'Спасибо за обращение.' },
});
